<template>
  <v-card class="restaurant-card">
    <v-img height="200px" v-bind:src="restaurant.pictures[0]"></v-img>
    <v-card-title id="card-title" align="left">
      {{ restaurant.name }}
    </v-card-title>
    <div class="ml-3 font-italic text-sm-body-2">
      {{ restaurant.address }}
    </div>
    <v-rating
      :value="restaurant.rating"
      color="orange"
      background-color="grey"
      half-increments
      readonly
      dense
      class="ml-3"
      size="16"
    ></v-rating>
    <div class="ml-3">{{ visitNumber }} visits</div>
    <v-card-actions>
      <v-btn class="more-info-button"
             color="primary"
             text
             outlined
      >
        <router-link
          style="text-decoration: none; color: inherit;"
          :to="{
          name: 'Restaurant',
          params: {
            userId: '604cc220ef6fa10004dc0179',
            restaurant: restaurant
            }
          }"
        >More info </router-link>
      </v-btn>

      <v-btn class="more-info-button" color="primary" @click="toggleVisits" text outlined> See visits
        <v-icon v-if="!visitsToggled">mdi-chevron-down</v-icon>
        <v-icon v-else>mdi-chevron-up</v-icon>
      </v-btn>

    </v-card-actions>
    <div v-show="visitsToggled">
      <div class="visit" v-for="(visit, index) in visits" :key="index">
        <div style="display: flex; flex-direction: row">
        You gave {{ visit.rating }} stars
          <v-spacer></v-spacer>
        <ModalVisitUser
          v-bind:restaurant-id="restaurant.id"
          v-bind:modal-visible="modalVisible"
          v-bind:restaurant-name="restaurant.name"
          v-bind:visit ="visit"
        />
        </div>

      </div>
    </div>
  </v-card>
</template>

<script>
import ModalVisitUser from "../User/Modals/ModalVisitUser";
export default {
  name: "restaurant-card",
  components: {ModalVisitUser},
  props: ['getRestaurantVisits', 'restaurant', 'userToken'],

  data: () => ({
    visits: [],
    visitsToggled: false,
    modalVisible: false
  }),
  computed: {
    visitNumber() {
      return this.visits.length;
    }
  },

  methods: {
    toggleVisits() {
      this.visitsToggled = !this.visitsToggled
    },

    openModal(visit_id) {
      console.log(visit_id)
    }
  },

  async created() {
    this.visits = await this.getRestaurantVisits(this.userToken,this.restaurant.id);
    this.visits = this.visits["items"]
  }
}
</script>

<style scoped>
.restaurant-card {
  position: relative;
}

.more-info-button {
  font-family: Arial, Helvetica, sans-serif;
}

#card-title {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}


.visit {
  margin: max(1vh, 1vw);
}
</style>
